/**
 * LE RETOUR DU CONSENTEMENT D'UN CONNECTEUR. Apres l'ecran du fournisseur
 * (Google, Microsoft), le serveur renvoie le navigateur sur
 * `/settings?t=conversations&connecteur=ok|refuse|erreur[&detail=maj|droits|non_configure]`
 * (`functions/src/connexions/oauth.ts`). La section Connecteurs le dit en une ligne,
 * puis retire ces deux parametres de l'adresse : un F5 ne doit pas redire
 * « Connecteur ajouté. ».
 *
 * FONCTIONS PURES, sans React ni `@taki/ui` : `tests/connecteurs-section.test.mjs`
 * les tient depuis `dist/`.
 */

export const PARAMETRES_RETOUR = ['connecteur', 'detail'] as const;

export interface MessageDeRetour {
  tone: 'status' | 'error';
  texte: string;
}

/** Le message a montrer pour une adresse (`location.search`), ou `null` si ce n'est pas un retour. */
export function messageDuRetour(search: string): MessageDeRetour | null {
  const parametres = new URLSearchParams(search);
  const issue = parametres.get('connecteur');
  if (issue === null || issue === '') return null;
  const detail = parametres.get('detail');
  /* `maj` : une connexion existante reconnectee, ou montee de niveau. */
  if (issue === 'ok') return { tone: 'status', texte: detail === 'maj' ? 'Connecteur mis à jour.' : 'Connecteur ajouté.' };
  /* LE DETAIL GAGNE : il nomme la cause, la ou l'issue seule dit « non ». */
  if (detail === 'droits') return { tone: 'error', texte: 'Droits refusés chez le fournisseur.' };
  if (detail === 'non_configure') return { tone: 'error', texte: 'Fournisseur non configuré.' };
  if (issue === 'refuse') return { tone: 'status', texte: 'Connexion annulée.' };
  return { tone: 'error', texte: 'Connexion impossible.' };
}

/** L'adresse sans les parametres du retour (`t=conversations` et le reste restent), ou `null` si rien a retirer. */
export function adresseSansRetour(href: string): string | null {
  const url = new URL(href);
  if (!PARAMETRES_RETOUR.some((clef) => url.searchParams.has(clef))) return null;
  for (const clef of PARAMETRES_RETOUR) url.searchParams.delete(clef);
  return `${url.pathname}${url.search}${url.hash}`;
}

/** « 13 oct. 2026 », ou « Jamais ». */
export function derniereUtilisation(date: Date | null): string {
  if (date === null || Number.isNaN(date.getTime())) return 'Jamais';
  return new Intl.DateTimeFormat('fr-LU', { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
}
